import { MarkunreadMailbox } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { List } from "@dzambalaorg/ui-kit";

import { StyledPaper } from "../styled";

export const ClaimSection = () => {
  return (
    <StyledPaper>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.mechanics.claim" />
          </List.Subheader>
        }
      >
        <List.ItemButton<typeof RouterLink> component={RouterLink} to="/claim">
          <List.ItemIcon>
            <MarkunreadMailbox />
          </List.ItemIcon>
          <List.ItemText>
            <FormattedMessage id="pages.claim.title" />
          </List.ItemText>
        </List.ItemButton>
      </List>
    </StyledPaper>
  );
};
